import ThreadableCanvas from './src/ThreadableCanvas';

export default ThreadableCanvas;
